import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 自动售货机
export default [{
  path: "/user/userAccount",
  name: "userAccount",
  component: function component() {
    return import("../../../views/userAccount/userAccount");
  },
  meta: {
    title: "汇付支付",
    foot: true
  }
}, {
  path: "/user/windAccount",
  name: "windAccount",
  component: function component() {
    return import("../../../views/userAccount/windAccount");
  },
  meta: {
    title: "汇付支付",
    foot: true
  }
}];